function initAlerts() {
	$('.js-close-alert').on('click', function() {
		$(this).closest('.alert').fadeOut().remove();
	});
}

export function init() {
	initAlerts();
}

